/**
 * Turn a key press into the combination string the desktop shell registers
 * (for example "Ctrl+Shift+Space"). Returns null while only modifiers are held.
 */
const MODIFIER_CODES = new Set([
  'ControlLeft',
  'ControlRight',
  'ShiftLeft',
  'ShiftRight',
  'AltLeft',
  'AltRight',
  'MetaLeft',
  'MetaRight',
])

export function comboFromEvent(event: KeyboardEvent): string | null {
  if (MODIFIER_CODES.has(event.code)) return null
  const key = event.code.replace(/^Key/, '').replace(/^Digit/, '')
  if (!key) return null
  const parts: string[] = []
  if (event.ctrlKey) parts.push('Ctrl')
  if (event.altKey) parts.push('Alt')
  if (event.shiftKey) parts.push('Shift')
  if (event.metaKey) parts.push('Super')
  // A bare letter would swallow typing everywhere; only F-keys may stand alone.
  if (parts.length === 0 && !/^F\d+$/.test(key)) return null
  return [...parts, key].join('+')
}
